export default function defaultValue(defaultValue: string) {
  return (text: string | undefined) => text || defaultValue
}
